const INSTAGRAM_ACCOUNTS = [
    {username: 'funky_coder', name:'Funky Coder'},
    {username: 'success.cool_', name:'Success Cool'},
    {username: 'ultimate.money_mindset', name:'Unique Mindset'},
    {username: 'pranaypise_', name:'Pranay Pise'},
]

export {
    INSTAGRAM_ACCOUNTS
}